import React from "react";
import "../style/gallery.css";

// import all gallery images here
import gal1 from "../assets/gallery1.jpg";
import gal2 from "../assets/gallery2.jpg";
import gal3 from "../assets/gallery3.jpg";
import gal4 from "../assets/gallery4.jpg";
import gal5 from "../assets/gallery5.jpg";
import gal6 from "../assets/gallery6.jpg";
import gal7 from "../assets/gallery7.jpg";
import gal8 from "../assets/gallery8.jpg";

const galleryItems = [
  { id: 1, img: gal1 },
  { id: 2, img: gal2 },
  { id: 3, img: gal3 },
  { id: 4, img: gal4 },
  { id: 5, img: gal5 },
  { id: 6, img: gal6 },
  { id: 7, img: gal7 },
  { id: 8, img: gal8 },
];

const HospitalGallery = () => {
  return (
    <div className="gallery-section">
      <div className="container">
        <div className="gallery-je">
          <div className="gallery-head-jp">
            <span className="gallery-title">— Hospital Gallery —</span>
          </div>

          <div className="gallery-grid">
            {galleryItems.map((item) => (
              <div key={item.id} className="gallery-card">
                <img src={item.img} alt="Hospital" className="gallery-img" />
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default HospitalGallery;
